import office from '@/taskpane/officejs/office-wrapper'
import officeApiWrapper from '@/taskpane/common/office-api-wrapper'
import CallbackArgs, { defaultCallbackArgs } from './callback-args'
import broadcastMessageToPortals from './broadcast-message-to-portals'
import TimeInfo from '../models/time-info'
import EventInfo from '../models/event-info'

interface EventItemApiDataArgs extends CallbackArgs {
  time: TimeInfo | null
  seriesId: string
  iCalUId: string
}

export async function sendItemApiDataEvent(): Promise<void> {
  const apiInfo = await getEventItemApiData()

  if (apiInfo) {
    const args = defaultCallbackArgs() as EventItemApiDataArgs
    args.time = apiInfo.time
    args.seriesId = apiInfo.uid
    args.iCalUId = apiInfo.iCalUId

    broadcastMessageToPortals('EventItemApiData', args)
  }
}

async function getEventItemApiData(): Promise<EventInfo | null> {
  if (officeApiWrapper.isAvailable()) {
    try {
      const id = (await office.id()) || (await office.save())
      return await officeApiWrapper.getEventInfo(id)
    } catch {
      // officeApiWrapper.setAsUnavailable()
      return null
    }
  } else {
    return null
  }
}
